import { gql } from '@apollo/client';

export const CREATE_UPPER_AIR_WEATHER_STATION = gql`
    mutation CreateUpperAirWeatherStation($input: CreateUpperAirWeatherStation!) {
        facility {
            process {
                createUpperAirWeatherStation(input: $input) {
                    id
                }
            }
        }
    }
`;
